<template>
  <div class="date-container">
    <div class="date-content">
      <div
        class="date-operation"
        @click="prevDateHandle"
      >
        ⬅
      </div>
      <ul>
        <li
          v-for="(item,index) in dateData"
          :key="index"
          :class="[todayClass(item),activeClass(item),weekClass(item),isPublish(item)]"
          @click="selectItem(item)"
          :title="item.fullDate"
        >
          <span class="item-week">{{item.week}}</span>
          <span class="item-date">{{item.date}}</span>
          <span
            class="isPublishState"
            title="已发布"
          ></span>
        </li>
      </ul>
      <div
        class="date-operation"
        @click="nextDateHandle"
      >
        ➡
      </div>
    </div>
  </div>
</template>

<script>
import { dateConvert, dateFun } from '@/components/tools/date-convert'
export default {
  data() {
    return {
      dateData: [],
      today: {},
      currentDay: {}
    }
  },
  props: {
    // 当前时间的dateTime eg:2019-05-29
    currentDate: {
      type: String,
      default: ''
    },
    publishhDateState: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    prevDateHandle() {
      this.currentDay = this.prevDate(new Date(this.currentDay.fullDate).getTime(), 1)
      this.setDateData(this.currentDay)
      this.$emit("prevDateHandle", this.currentDay)
    },
    nextDateHandle() {
      this.currentDay = this.nextDate(new Date(this.currentDay.fullDate).getTime(), 1)
      this.setDateData(this.currentDay)
      this.$emit("prevDateHandle", this.currentDay)
    },
    selectItem(item) {
      this.currentDay = item
      this.$emit("selectItemHandle", this.currentDay)
    },
    todayClass(item) {
      return item.fullDate === this.today.fullDate ? 'today' : ''
    },
    activeClass(item) {
      return item.fullDate === this.currentDay.fullDate ? 'active' : ''
    },
    weekClass(item) {
      return item.week === '六' || item.week === '日' ? 'weekend' : ''
    },
    isPublish(item) {
      // console.log(item.date, item.isPublish)
      return item.isPublish ? 'isPublish' : ''
    },
    prevDate(d, i) {
      let prevDate = dateFun.setPrevDate(d, i)

      return {
        week: dateConvert.convert(prevDate, 'w').substring(2),
        date: dateConvert.convert(prevDate, 'MM-dd'),
        fullDate: dateConvert.convert(prevDate, 'yyyy-MM-dd'),
        isPublish: false
      }
    },
    nextDate(d, i) {
      let nextDate = dateFun.setNextDate(dateConvert.convert(d, 'yyyy-MM-dd'), i)
      return {
        week: dateConvert.convert(nextDate, 'w').substring(2),
        date: dateConvert.convert(nextDate, 'MM-dd'),
        fullDate: dateConvert.convert(nextDate, 'yyyy-MM-dd'),
        isPublish: false
      }
    },
    createItemDate(dateObj) {
      return {
        week: dateConvert.convert(dateObj, 'w').substring(2),
        date: dateConvert.convert(dateObj, 'MM-dd'),
        fullDate: dateConvert.convert(dateObj, 'yyyy-MM-dd'),
        isPublish: false
      }
    },
    setDateData(currentObj) {
      this.dateData = []
      this.dateData.push(currentObj)
      let currentDateTime = new Date(currentObj.fullDate).getTime()
      for (let i = 1; i <= 7; i++) {
        this.dateData.unshift(this.prevDate(currentDateTime, i))
        this.dateData.push(this.nextDate(currentDateTime, i))
      }
    }

  },
  created() {
    let todayDate = new Date().getTime()
    this.today = this.createItemDate(todayDate)
    this.currentDay = this.today
    this.setDateData(this.today)
  },
  watch: {
    currentDate: function (data) {
      let currentTime = data !== '' ? new Date(data).getTime() : new Date().getTime()
      this.currentDay = this.createItemDate(currentTime)
      this.setDateData(this.currentDay)
    },
    publishhDateState: function (data) {
      if (data.length) {
        data.forEach((item, index) => {
          if (item.date === this.dateData[index].fullDate) {
            this.dateData[index].isPublish = item.isPublish
          }
        })
      }
      // console.log(data, this.dateData)
    }
  }
}
</script>

<style lang="less" scoped>
.date-container {
  border: 1px solid #ddd;
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;

  .date-content {
    width: 100%;
    height: 100%;
    display: flex;
    background: #fff;
    cursor: pointer;

    .date-operation {
      width: 30px;
    }
    .date-operation:hover {
      background: #eeeeee;
    }
    ul {
      width: calc(100% - 60px);
      padding-inline-start: 0;
      list-style: none;
      display: flex;
      overflow: hidden;
      height: 100%;

      li {
        min-width: calc(100% / 15);
        border-right: 1px solid #ddd;
        height: 100%;
        color: #337ab7;

        &.isPublish {
          position: relative !important;

          .isPublishState {
            position: absolute;
            top: 2px;
            right: 2px;
            display: block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #00ff00;
          }
        }

        &:nth-child(1) {
          border-left: 1px solid #ddd;
        }
        &:hover {
          background: #88b5db !important;
          color: #fff !important;
        }
        .item-week {
          display: block;
          line-height: 20px;
        }
        .item-date {
          display: block;
          line-height: 28px;
        }

        &.active {
          background: #337ab7 !important;
          color: #fff !important;
        }
        &.today {
          background: #88b5db;
          color: #fff;
        }
        &.weekend {
          background: #f0f0f0;
          color: #337ab7;
        }
      }
    }
  }
}
</style>

